import * as React from "react";
import { tokens, colors } from "./coreConstants";

interface FillProps {
  fill?: string;
}

export const Check: React.FC<FillProps> = ({
  fill = colors.mediumGreen,
}: FillProps) => (
  <svg
    width="16"
    height="13"
    viewBox="0 0 16 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8024 2.59735L6.19309 12.8818C5.93113 13.1622 5.50809 13.1604 5.24825 12.8777L0.193784 7.38024C-0.0660629 7.0976 -0.0643926 6.64118 0.197626 6.36077L1.46256 5.00699C1.72453 4.72664 2.14756 4.72844 2.40741 5.01114L5.73648 8.63207L13.6066 0.209084C13.8686 -0.0712693 14.2916 -0.0694667 14.5515 0.21317L15.8062 1.57787C16.0661 1.86057 16.0644 2.31699 15.8024 2.59735Z"
      fill={fill}
    />
  </svg>
);

export const Cross: React.FC<FillProps> = ({
  fill = colors.brightRed,
}: FillProps) => (
  <svg
    width="11"
    height="10"
    viewBox="0 0 11 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1573 9.64301C9.73006 10.0703 9.03731 10.0703 8.61003 9.64301L5.51432 6.5473L2.41861 9.64301C1.99134 10.0703 1.29859 10.0703 0.871309 9.64301C0.444033 9.21573 0.444032 8.52298 0.871309 8.0957L3.96702 4.99999L0.871308 1.90429C0.444032 1.47701 0.444033 0.784258 0.871309 0.356981C1.29859 -0.0702954 1.99134 -0.0702955 2.41862 0.356981L5.51432 3.45269L8.61003 0.356981C9.03731 -0.0702962 9.73006 -0.0702955 10.1573 0.356981C10.5846 0.784258 10.5846 1.47701 10.1573 1.90429L7.06163 4.99999L10.1573 8.0957C10.5846 8.52298 10.5846 9.21573 10.1573 9.64301Z"
      fill={fill}
    />
  </svg>
);

export const X: React.FC<FillProps> = ({ fill = "#000" }: FillProps) => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.831055"
        y="2.66846"
        width="2.88991"
        height="13.7271"
        rx="1"
        transform="rotate(-45 0.831055 2.66846)"
        fill={fill}
      />
      <rect
        x="2.875"
        y="12.375"
        width="2.88991"
        height="13.7271"
        rx="1"
        transform="rotate(-135 2.875 12.375)"
        fill={fill}
      />
    </svg>
  );
};

export const BackArrow: React.FC<FillProps> = ({
  fill = "#22222",
}: FillProps) => (
  <svg
    width="10"
    height="18"
    viewBox="0 0 10 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.2859 14.4231C8.40432 14.4231 8.53755 14.367 8.62637 14.2828L9.36652 13.5814C9.45534 13.4972 9.51455 13.371 9.51455 13.2588C9.51455 13.1465 9.45534 13.0203 9.36652 12.9361L3.54892 7.4231L9.36652 1.91007C9.45534 1.8259 9.51455 1.69965 9.51455 1.58742C9.51455 1.46117 9.45534 1.34895 9.36652 1.26478L8.62637 0.563376C8.53755 0.479208 8.40432 0.423096 8.2859 0.423096C8.16748 0.423096 8.03425 0.479208 7.94543 0.563376L1.0472 7.10045C0.958382 7.18462 0.89917 7.31087 0.89917 7.4231C0.89917 7.53532 0.958382 7.66157 1.0472 7.74574L7.94543 14.2828C8.03425 14.367 8.16748 14.4231 8.2859 14.4231Z"
      fill={fill}
    />
  </svg>
);

export const Pencil: React.FC<FillProps> = ({
  fill = "#0AA96C",
}: FillProps) => (
  <svg
    width="11"
    height="14"
    viewBox="0 0 11 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.1808 9.2981H2.46429V8.44095H1.60714V7.72443L2.21652 7.11506L3.79018 8.68872L3.1808 9.2981ZM6.68304 3.08381C6.68304 3.12399 6.66964 3.16417 6.63616 3.19765L3.0067 6.82711C2.97321 6.8606 2.93304 6.87399 2.89286 6.87399C2.8058 6.87399 2.74554 6.81372 2.74554 6.72667C2.74554 6.68649 2.75893 6.64631 2.79241 6.61283L6.42188 2.98336C6.45536 2.94988 6.49554 2.93649 6.53571 2.93649C6.62277 2.93649 6.68304 2.99676 6.68304 3.08381ZM6.32143 1.7981L0.75 7.36952V10.1552H3.53571L9.10714 4.58381L6.32143 1.7981ZM10.8951 2.44095C10.8951 2.21327 10.8013 1.99229 10.6473 1.83158L9.07366 0.264613C8.91295 0.103899 8.69196 0.0101488 8.46429 0.0101488C8.23661 0.0101488 8.01562 0.103899 7.86161 0.264613L6.75 1.36952L9.53571 4.15524L10.6473 3.04363C10.8013 2.88961 10.8951 2.66863 10.8951 2.44095Z"
      fill={fill}
    />
  </svg>
);

export const Duplicate: React.FC<FillProps> = (props: FillProps) => {
  const { fill = tokens["ds-color-gray-darkest"] } = props;
  return (
    <svg
      width="15"
      height="12"
      viewBox="0 0 15 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7069 1.01234H3.49346V7.56176H13.7069V1.01234ZM2.49346 0.0123377V8.56176H14.7069V0.0123377H2.49346Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.11709 2.55371H0.495531V11.1147H12.709V7.91155H11.709V10.1147H1.49553V3.55371H3.11709V2.55371Z"
        fill={fill}
      />
    </svg>
  );
};

export const Trash: React.FC = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.28578 5.57139V10.7142C5.28578 10.7976 5.259 10.866 5.20543 10.9196C5.15185 10.9732 5.0834 11 5.00007 11H4.42864C4.34531 11 4.27686 10.9732 4.22328 10.9196C4.16971 10.866 4.14293 10.7976 4.14293 10.7142V5.57139C4.14293 5.48806 4.16971 5.41961 4.22328 5.36604C4.27686 5.31246 4.34531 5.28568 4.42864 5.28568H5.00007C5.0834 5.28568 5.15185 5.31246 5.20543 5.36604C5.259 5.41961 5.28578 5.48806 5.28578 5.57139ZM7.5715 5.57139V10.7142C7.5715 10.7976 7.54471 10.866 7.49114 10.9196C7.43757 10.9732 7.36912 11 7.28578 11H6.71435C6.63102 11 6.56257 10.9732 6.509 10.9196C6.45543 10.866 6.42864 10.7976 6.42864 10.7142V5.57139C6.42864 5.48806 6.45543 5.41961 6.509 5.36604C6.56257 5.31246 6.63102 5.28568 6.71435 5.28568H7.28578C7.36912 5.28568 7.43757 5.31246 7.49114 5.36604C7.54471 5.41961 7.5715 5.48806 7.5715 5.57139ZM9.85721 5.57139V10.7142C9.85721 10.7976 9.83043 10.866 9.77685 10.9196C9.72328 10.9732 9.65483 11 9.5715 11H9.00007C8.91674 11 8.84828 10.9732 8.79471 10.9196C8.74114 10.866 8.71435 10.7976 8.71435 10.7142V5.57139C8.71435 5.48806 8.74114 5.41961 8.79471 5.36604C8.84828 5.31246 8.91674 5.28568 9.00007 5.28568H9.5715C9.65483 5.28568 9.72328 5.31246 9.77685 5.36604C9.83043 5.41961 9.85721 5.48806 9.85721 5.57139ZM11.0001 12.0357V3.57139H3.00007V12.0357C3.00007 12.1666 3.0209 12.2872 3.06257 12.3973C3.10424 12.5074 3.14739 12.5878 3.19203 12.6384C3.23668 12.689 3.26793 12.7142 3.28578 12.7142H10.7144C10.7322 12.7142 10.7635 12.689 10.8081 12.6384C10.8527 12.5878 10.8959 12.5074 10.9376 12.3973C10.9792 12.2872 11.0001 12.1666 11.0001 12.0357ZM5.00007 2.42854H9.00007L8.5715 1.38389C8.52983 1.33032 8.47924 1.29758 8.41971 1.28568H5.58935C5.52983 1.29758 5.47924 1.33032 5.43757 1.38389L5.00007 2.42854ZM13.2858 2.71425V3.28568C13.2858 3.36901 13.259 3.43746 13.2054 3.49104C13.1519 3.54461 13.0834 3.57139 13.0001 3.57139H12.1429V12.0357C12.1429 12.5297 12.003 12.9568 11.7233 13.3169C11.4435 13.677 11.1072 13.8571 10.7144 13.8571H3.28578C2.89293 13.8571 2.55662 13.683 2.27686 13.3348C1.99709 12.9866 1.85721 12.5654 1.85721 12.0714V3.57139H1.00007C0.916736 3.57139 0.848284 3.54461 0.794713 3.49104C0.741141 3.43746 0.714355 3.36901 0.714355 3.28568V2.71425C0.714355 2.63092 0.741141 2.56246 0.794713 2.50889C0.848284 2.45532 0.916736 2.42854 1.00007 2.42854H3.759L4.384 0.937465C4.47328 0.717227 4.634 0.529727 4.86614 0.374965C5.09828 0.220203 5.3334 0.142822 5.5715 0.142822H8.42864C8.66674 0.142822 8.90185 0.220203 9.134 0.374965C9.36614 0.529727 9.52685 0.717227 9.61614 0.937465L10.2411 2.42854H13.0001C13.0834 2.42854 13.1519 2.45532 13.2054 2.50889C13.259 2.56246 13.2858 2.63092 13.2858 2.71425Z"
      fill="black"
    />
  </svg>
);

export const ExclamationMark: React.FC = () => (
  <svg
    width="5"
    height="8"
    viewBox=".5 0 2 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.14118 5.91851C2.14118 5.76226 2.01172 5.63279 1.85547 5.63279H0.712612C0.556362 5.63279 0.426897 5.76226 0.426897 5.91851V6.91851C0.426897 7.07476 0.556362 7.20422 0.712612 7.20422H1.85547C2.01172 7.20422 2.14118 7.07476 2.14118 6.91851V5.91851ZM2.27511 1.20422C2.27958 1.04797 2.15458 0.918509 1.99833 0.918509H0.569754C0.413504 0.918509 0.288504 1.04797 0.292969 1.20422L0.417969 4.63279C0.422433 4.78904 0.556362 4.91851 0.712612 4.91851H1.85547C2.01172 4.91851 2.14565 4.78904 2.15011 4.63279L2.27511 1.20422Z"
      fill={tokens["ds-color-white"]}
    />
  </svg>
);

export const Plus: React.FC = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.41322 11.4215C6.82801 11.4215 7.16453 11.085 7.16453 10.6702V7.41453H10.4202C10.835 7.41453 11.1715 7.07801 11.1715 6.66322V5.16061C11.1715 4.74583 10.835 4.40931 10.4202 4.40931H7.16453V1.15365C7.16453 0.738866 6.82801 0.402344 6.41322 0.402344H4.91061C4.49583 0.402344 4.15931 0.738866 4.15931 1.15365V4.40931H0.903649C0.488866 4.40931 0.152344 4.74583 0.152344 5.16061V6.66322C0.152344 7.07801 0.488866 7.41453 0.903649 7.41453H4.15931V10.6702C4.15931 11.085 4.49583 11.4215 4.91061 11.4215H6.41322Z"
        fill={tokens["ds-color-gray-darkest"]}
      />
    </svg>
  );
};

export const Eye: React.FC<FillProps> = ({ fill }: FillProps) => {
  return (
    <svg
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 0C3.582 0 0 5 0 6C0 7 3.582 12 8 12C12.418 12 16 7 16 6C16 5 12.418 0 8 0ZM8 3.66667C6.71133 3.66667 5.66667 4.71133 5.66667 6C5.66667 7.28867 6.71133 8.33333 8 8.33333C9.28867 8.33333 10.3333 7.28867 10.3333 6C10.3333 4.71133 9.28867 3.66667 8 3.66667ZM4.33333 6C4.33333 8.02533 5.97467 9.66667 8 9.66667C10.0247 9.66667 11.6667 8.02533 11.6667 6C11.6667 3.97467 10.0253 2.33333 8 2.33333C5.97467 2.33333 4.33333 3.97467 4.33333 6Z"
        fill={fill}
      />
    </svg>
  );
};

export const Close: React.FC<FillProps> = ({
  fill = tokens["ds-color-gray-darkest"],
}: FillProps) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.292893 0.292893C0.653377 -0.0675907 1.22061 -0.0953203 1.6129 0.209705L1.70711 0.292893L13.7071 12.2929C14.0976 12.6834 14.0976 13.3166 13.7071 13.7071C13.3466 14.0676 12.7794 14.0953 12.3871 13.7903L12.2929 13.7071L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683418 0.292893 0.292893Z"
        fill={fill}
      />
      <path
        d="M12.2929 0.292893C12.6834 -0.0976311 13.3166 -0.0976311 13.7071 0.292893C14.0676 0.653377 14.0953 1.22061 13.7903 1.6129L13.7071 1.70711L1.70711 13.7071C1.31658 14.0976 0.683418 14.0976 0.292893 13.7071C-0.0675907 13.3466 -0.0953203 12.7794 0.209705 12.3871L0.292893 12.2929L12.2929 0.292893Z"
        fill={fill}
      />
    </svg>
  );
};

export const Dropdown: React.FC<FillProps> = ({
  fill = tokens["ds-color-white"],
}: FillProps) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.89418 4.83146C3.17127 4.58901 3.59244 4.61709 3.8349 4.89418L7.99985 9.65412L12.1648 4.89418C12.4073 4.61709 12.8284 4.58901 13.1055 4.83146C13.3826 5.07392 13.4107 5.49509 13.1682 5.77218L8.50156 11.1055C8.37497 11.2502 8.19209 11.3332 7.99985 11.3332C7.80761 11.3332 7.62472 11.2502 7.49813 11.1055L2.83146 5.77218C2.58901 5.49509 2.61709 5.07392 2.89418 4.83146Z"
        fill={fill}
      />
    </svg>
  );
};

export const Dash: React.FC<FillProps> = ({ fill }: FillProps) => (
  <svg
    width="14"
    height="3"
    viewBox="0 0 14 3"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      y="2.94531"
      width="2.88991"
      height="13.7271"
      rx="1"
      transform="rotate(-90.0048 0 2.94531)"
      fill={fill}
    />
  </svg>
);

export const SettingsWheel: React.FC = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.8852 9.8775C15.9199 9.59625 15.943 9.30375 15.943 9C15.943 8.69625 15.9199 8.40375 15.8736 8.1225L17.8292 6.6375C18.0028 6.5025 18.0491 6.255 17.9449 6.06375L16.0935 2.9475C15.9777 2.745 15.7347 2.6775 15.5264 2.745L13.2237 3.645C12.7377 3.285 12.2285 2.9925 11.6615 2.7675L11.3143 0.3825C11.2796 0.1575 11.0829 0 10.8515 0H7.14853C6.91709 0 6.73195 0.1575 6.69723 0.3825L6.35008 2.7675C5.78307 2.9925 5.26234 3.29625 4.7879 3.645L2.48513 2.745C2.27684 2.66625 2.03384 2.745 1.91812 2.9475L0.0666476 6.06375C-0.0490694 6.26625 -0.00278243 6.5025 0.182365 6.6375L2.13798 8.1225C2.0917 8.40375 2.05698 8.7075 2.05698 9C2.05698 9.2925 2.08012 9.59625 2.12641 9.8775L0.170793 11.3625C-0.0027827 11.4975 -0.0490694 11.745 0.0550759 11.9362L1.90655 15.0525C2.02226 15.255 2.26527 15.3225 2.47356 15.255L4.77633 14.355C5.26234 14.715 5.7715 15.0075 6.33851 15.2325L6.68566 17.6175C6.73195 17.8425 6.91709 18 7.14853 18H10.8515C11.0829 18 11.2796 17.8425 11.3028 17.6175L11.6499 15.2325C12.2169 15.0075 12.7377 14.7038 13.2121 14.355L15.5149 15.255C15.7232 15.3338 15.9662 15.255 16.0819 15.0525L17.9334 11.9362C18.0491 11.7337 18.0028 11.4975 17.8176 11.3625L15.8852 9.8775ZM9 12.375C7.09067 12.375 5.52849 10.8562 5.52849 9C5.52849 7.14375 7.09067 5.625 9 5.625C10.9093 5.625 12.4715 7.14375 12.4715 9C12.4715 10.8562 10.9093 12.375 9 12.375Z"
      fill="black"
    />
  </svg>
);

export const RadioIcon: React.FC = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="5" cy="5" r="5" fill="black" />
    <circle cx="5.00098" cy="4.99805" r="2.5" fill="white" />
  </svg>
);

export const CheckBoxIcon: React.FC = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="10" height="10" rx="1" fill="black" />
    <mask
      id="mask0"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="1"
      y="2"
      width="8"
      height="6"
    >
      <path
        d="M8.525 3.35529C8.525 3.47482 8.48317 3.57641 8.3995 3.66008L5.15441 6.90517L4.54484 7.51475C4.46117 7.59842 4.35957 7.64025 4.24005 7.64025C4.12052 7.64025 4.01893 7.59842 3.93526 7.51475L3.32568 6.90517L1.70314 5.28263C1.61947 5.19896 1.57764 5.09736 1.57764 4.97784C1.57764 4.85831 1.61947 4.75672 1.70314 4.67305L2.31271 4.06348C2.39638 3.97981 2.49798 3.93798 2.6175 3.93798C2.73703 3.93798 2.83862 3.97981 2.92229 4.06348L4.24005 5.38572L7.18035 2.44093C7.26402 2.35726 7.36562 2.31543 7.48514 2.31543C7.60467 2.31543 7.70626 2.35726 7.78993 2.44093L8.3995 3.05051C8.48317 3.13417 8.525 3.23577 8.525 3.35529Z"
        fill="black"
      />
    </mask>
    <g mask="url(#mask0)">
      <rect x="0.419922" width="9.26316" height="9.26316" fill="white" />
    </g>
  </svg>
);

export const Picture: React.FC<FillProps> = ({
  fill = "#323232",
}: FillProps) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.70366 7.39415C9.70366 6.85615 9.28135 6.41748 8.76201 6.41748C8.24267 6.41748 7.82037 6.85615 7.82037 7.39415C7.82037 7.93359 8.24267 8.3723 8.76201 8.3723C9.28135 8.3723 9.70366 7.93359 9.70366 7.39415Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.2841 2.69106C14.5491 2.73379 14.7303 2.99163 14.6892 3.26687L13.3385 12.3119C13.3189 12.444 13.2491 12.5623 13.1453 12.6413C13.0616 12.7049 12.9612 12.7387 12.8588 12.7387C12.834 12.7387 12.8091 12.7367 12.7842 12.7327L12.6757 12.7153V13.8918C12.6757 14.1704 12.4585 14.396 12.1902 14.396H0.975681C0.707848 14.396 0.490234 14.1704 0.490234 13.8918V4.73893C0.490234 4.46022 0.707848 4.23467 0.975681 4.23467H2.21345L2.64772 1.32631C2.66781 1.19416 2.73716 1.07591 2.84094 0.99692C2.94473 0.917926 3.07434 0.88464 3.20204 0.905506L14.2841 2.69106ZM12.6757 10.1701L13.6552 3.61066L3.53301 1.97962L3.1963 4.23467H12.1902C12.4585 4.23467 12.6757 4.46022 12.6757 4.73893V10.1701ZM11.7048 5.24321V12.5131C11.7048 12.5131 8.90527 10.3351 8.54765 10.3361C8.19361 10.3371 6.95181 11.7235 6.92667 11.7516C6.90644 11.7727 6.88449 11.7919 6.86183 11.8085C6.80501 11.85 6.74153 11.8774 6.6759 11.8907C6.52291 11.9215 6.35839 11.8753 6.24002 11.752C6.24002 11.752 4.52928 9.61267 4.18011 9.61267C3.8379 9.61267 1.51627 12.337 1.42392 12.4455L1.46113 5.24321H11.7048Z"
      fill={fill}
    />
  </svg>
);

export const CirclePicture: React.FC<FillProps> = ({
  fill = "#323232",
}: FillProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="12" fill="#F5F5F5" />
    <path
      d="M14.0806 11.4011C14.0806 10.8709 13.6644 10.4385 13.1525 10.4385C12.6407 10.4385 12.2245 10.8709 12.2245 11.4011C12.2245 11.9328 12.6407 12.3652 13.1525 12.3652C13.6644 12.3652 14.0806 11.9328 14.0806 11.4011Z"
      fill={fill}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.595 6.76582C18.8562 6.80793 19.0348 7.06206 18.9943 7.33333L17.6631 16.2479C17.6438 16.3782 17.5749 16.4947 17.4727 16.5726C17.3902 16.6353 17.2912 16.6686 17.1903 16.6686C17.1658 16.6686 17.1413 16.6666 17.1168 16.6627L17.0098 16.6455V17.8051C17.0098 18.0797 16.7958 18.3021 16.5313 18.3021H5.47845C5.21448 18.3021 5 18.0797 5 17.8051V8.78417C5 8.50947 5.21448 8.28717 5.47845 8.28717H6.69837L7.12638 5.42074C7.14618 5.29049 7.21453 5.17395 7.31682 5.0961C7.41911 5.01825 7.54685 4.98544 7.67271 5.006L18.595 6.76582ZM17.0098 14.1371L17.9751 7.67217L7.99891 6.06463L7.66706 8.28717H16.5313C16.7958 8.28717 17.0098 8.50947 17.0098 8.78417V14.1371ZM16.0529 9.28117V16.4463C16.0529 16.4463 13.2937 14.2996 12.9413 14.3007C12.5923 14.3017 11.3684 15.6681 11.3436 15.6957C11.3237 15.7165 11.3021 15.7355 11.2797 15.7518C11.2237 15.7928 11.1612 15.8197 11.0965 15.8328C10.9457 15.8632 10.7836 15.8176 10.6669 15.6961C10.6669 15.6961 8.98083 13.5876 8.63668 13.5876C8.29941 13.5876 6.01125 16.2727 5.92023 16.3796L5.9569 9.28117H16.0529Z"
      fill={fill}
    />
  </svg>
);

export const Magnify: React.FC<FillProps> = ({
  fill = tokens["ds-color-gray-darkest"],
}: FillProps) => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.857 6.42829C10.857 5.3271 10.4656 4.38514 9.6829 3.6024C8.90016 2.81966 7.95819 2.42829 6.857 2.42829C5.75581 2.42829 4.81385 2.81966 4.03111 3.6024C3.24837 4.38514 2.857 5.3271 2.857 6.42829C2.857 7.52948 3.24837 8.47145 4.03111 9.25418C4.81385 10.0369 5.75581 10.4283 6.857 10.4283C7.95819 10.4283 8.90016 10.0369 9.6829 9.25418C10.4656 8.47145 10.857 7.52948 10.857 6.42829ZM15.4284 13.8569C15.4284 14.1664 15.3153 14.4342 15.0891 14.6604C14.863 14.8866 14.5951 14.9997 14.2856 14.9997C13.9641 14.9997 13.6963 14.8866 13.482 14.6604L10.4195 11.6069C9.35403 12.345 8.16653 12.714 6.857 12.714C6.00581 12.714 5.19182 12.5488 4.41504 12.2185C3.63825 11.8881 2.96861 11.4417 2.40611 10.8792C1.84361 10.3167 1.39718 9.64704 1.06682 8.87026C0.736468 8.09347 0.571289 7.27948 0.571289 6.42829C0.571289 5.5771 0.736468 4.76311 1.06682 3.98633C1.39718 3.20954 1.84361 2.5399 2.40611 1.9774C2.96861 1.4149 3.63825 0.968471 4.41504 0.638114C5.19182 0.307757 6.00581 0.142578 6.857 0.142578C7.70819 0.142578 8.52218 0.307757 9.29897 0.638114C10.0758 0.968471 10.7454 1.4149 11.3079 1.9774C11.8704 2.5399 12.3168 3.20954 12.6472 3.98633C12.9775 4.76311 13.1427 5.5771 13.1427 6.42829C13.1427 7.73782 12.7737 8.92532 12.0356 9.99079L15.0981 13.0533C15.3183 13.2735 15.4284 13.5414 15.4284 13.8569Z"
      fill={fill}
    />
  </svg>
);

export const DefaultLayout: React.FC<FillProps> = () => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.344238 0C0.164256 1.79955e-05 0.000506277 0.163768 0.000488281 0.34375V4.46875C0.000506277 4.64873 0.164256 4.81248 0.344238 4.8125H4.46924C4.64922 4.81248 4.81297 4.64873 4.81299 4.46875V0.34375C4.81297 0.163768 4.64922 1.79955e-05 4.46924 0H0.344238ZM6.53174 0C6.35176 1.79955e-05 6.18801 0.163768 6.18799 0.34375V4.46875C6.18801 4.64873 6.35176 4.81248 6.53174 4.8125H10.6567C10.8367 4.81248 11.0005 4.64873 11.0005 4.46875V0.34375C11.0005 0.163768 10.8367 1.79955e-05 10.6567 0H6.53174ZM0.687988 0.6875H4.12549V4.125H0.687988V0.6875ZM0.344238 6.1875C0.164256 6.18752 0.000506277 6.35127 0.000488281 6.53125V10.6562C0.000506277 10.8362 0.164256 11 0.344238 11H4.46924C4.64922 11 4.81297 10.8362 4.81299 10.6562V6.53125C4.81297 6.35127 4.64922 6.18752 4.46924 6.1875H0.344238ZM6.53174 6.1875C6.35176 6.18752 6.18801 6.35127 6.18799 6.53125V10.6562C6.18801 10.8362 6.35176 11 6.53174 11H10.6567C10.8367 11 11.0005 10.8362 11.0005 10.6562V6.53125C11.0005 6.35127 10.8367 6.18752 10.6567 6.1875H6.53174ZM6.87549 6.875H10.313V10.3125H6.87549V6.875Z"
      fill="black"
    />
  </svg>
);

export const SideBySideLayout: React.FC<FillProps> = () => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.344238 0.1875C0.164256 0.187518 0.000506277 0.351268 0.000488281 0.53125V10.6562C0.000506277 10.8362 0.164256 11 0.344238 11H4.46924C4.64922 11 4.81297 10.8362 4.81299 10.6562V0.53125C4.81297 0.351268 4.64922 0.187518 4.46924 0.1875H0.344238ZM6.53174 0.1875C6.35176 0.187518 6.18801 0.351268 6.18799 0.53125V10.6562C6.18801 10.8362 6.35176 11 6.53174 11H10.6567C10.8367 11 11.0005 10.8362 11.0005 10.6562V0.53125C11.0005 0.351268 10.8367 0.187518 10.6567 0.1875H6.53174ZM6.87549 0.875H10.313V10.3125H6.87549V0.875Z"
      fill="black"
    />
  </svg>
);

export const Lock: React.FC<FillProps> = ({ fill = "#898AAD" }: FillProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.09091 11.1818H15.6364V8.72727C15.6364 7.82386 15.3168 7.05256 14.6776 6.41335C14.0384 5.77415 13.267 5.45455 12.3636 5.45455C11.4602 5.45455 10.6889 5.77415 10.0497 6.41335C9.41051 7.05256 9.09091 7.82386 9.09091 8.72727V11.1818ZM19.7273 12.4091V19.7727C19.7273 20.1136 19.608 20.4034 19.3693 20.642C19.1307 20.8807 18.8409 21 18.5 21H6.22727C5.88636 21 5.59659 20.8807 5.35795 20.642C5.11932 20.4034 5 20.1136 5 19.7727V12.4091C5 12.0682 5.11932 11.7784 5.35795 11.5398C5.59659 11.3011 5.88636 11.1818 6.22727 11.1818H6.63636V8.72727C6.63636 7.15909 7.19886 5.8125 8.32386 4.6875C9.44886 3.5625 10.7955 3 12.3636 3C13.9318 3 15.2784 3.5625 16.4034 4.6875C17.5284 5.8125 18.0909 7.15909 18.0909 8.72727V11.1818H18.5C18.8409 11.1818 19.1307 11.3011 19.3693 11.5398C19.608 11.7784 19.7273 12.0682 19.7273 12.4091Z"
      fill={fill}
    />
  </svg>
);

export const PollIcon: React.FC<FillProps> = () => (
  <svg
    width="12"
    height="13"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 2.53691C0.753853 1.03277 2.30907 0 4.10585 0V4.59L0 2.53691Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.83739 6.90153V1.30804C8.92648 1.30804 11.4306 3.81231 11.4306 6.90153C11.4306 9.99074 8.92648 12.495 5.83739 12.495C2.7483 12.495 0.244141 9.99074 0.244141 6.90153C0.244141 6.0022 0.456805 5.15256 0.833914 4.39979L5.83718 6.90153H5.83739Z"
      fill="black"
    />
  </svg>
);

export const TrueFalse: React.FC<FillProps> = () => (
  <svg
    style={{ marginRight: "-0.4rem" }}
    transform="translate(-6)"
    width="16"
    height="16"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="8.00024"
      cy="8"
      r="5"
      transform="rotate(-45 8.00024 8)"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.05296 11.9993C9.05889 11.986 10.0608 11.5956 10.8283 10.8281C12.3904 9.26596 12.3904 6.7333 10.8283 5.17121C10.0608 4.40365 9.05889 4.01325 8.05296 3.99998L8.05296 11.9993Z"
      fill="white"
    />
  </svg>
);

export const AudioIcon: React.FC<FillProps> = () => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0)">
      <path
        opacity="0.6"
        d="M12.2759 4.26282C12.2759 4.26282 13.8979 4.7004 13.8979 6.97186C13.8979 9.24333 12.2759 9.62077 12.2759 9.62077"
        stroke="black"
        strokeWidth="1.14286"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        opacity="0.6"
        d="M12.5557 2.93921C13.2822 3.21312 15.161 4.18855 15.161 6.98445C15.161 9.78035 13.3092 10.6856 12.5726 10.9428"
        stroke="black"
        strokeWidth="1.14286"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M5.10228 9.63767H2.39897C2.21973 9.63767 2.04784 9.56727 1.9211 9.44198C1.79436 9.3167 1.72314 9.14678 1.72314 8.96959V5.03795C1.72314 4.86077 1.79436 4.69085 1.9211 4.56556C2.04784 4.44027 2.21973 4.36987 2.39897 4.36987H5.10228V9.63767Z"
        fill="black"
      />
      <path
        d="M4.94329 4.35618L9.69774 0.681759C10.0052 0.447932 10.5256 0.614927 10.5256 0.948966V13.0545C10.5256 13.3886 10.0052 13.5556 9.69774 13.3184L4.93652 9.644L4.94329 4.35618Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="15"
          height="12.8571"
          fill="white"
          transform="translate(0.5 0.571411)"
        />
      </clipPath>
    </defs>
  </svg>
);
